const featuredCardData = [
  {
    Id: '124443ewdr',
    image: 'https://s3.amazonaws.com/37assets/svn/765-default-avatar.png',
    name: 'Abhishek Sharma',
    designation: 'Product Designer',
    location: 'Bangalore, India',
    graduated: '2010',
    degree: 'M Tech',
    current_location: 'Bangalore',
    current_occupation: 'Entrepreneurship',
    current_company: 'Zoho',
    current_title: 'Project Lead',
    hobbies: 'Project Lead',
    personal_details: {
      about:
        'Lorem ipsum dolor sit amet consectetur. Pellentesque malesuada porta felis vestibulum volutpat volutpat imperdiet. Habitant ipsum hendrerit varius adipiscing augue sollicitudin sed. Pellentesque vel mauris quam neque urna. Amet scelerisque ut dolor duis dignissim in amet id proin.',
      Education: [
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2018',
          end_date: '2020',
          degree: 'Maters',
          field_of_study: 'Electronics and Media Technology',
          school: 'Presidency University',
        },
      ],
      work_experiance: [
        {
          start_date: '2021',
          end_date: '2022',
          designation: 'User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2022',
          end_date: '2023',
          designation: 'Senior User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2023',
          end_date: 'Present',
          designation: 'Project Lead',
          company_name: 'Lollipop Studio',
        },
      ],
      fun_fact: "The Ancient Romans used to drop a piece of toast into their wine for good health - hence why we 'raise a toast'.",
    },
  },
  {
    Id: '12444bvf32',
    image: 'https://cdn.pixabay.com/photo/2015/07/11/19/23/book-841171_640.jpg',
    name: 'Vidushi Rastogi',
    designation: 'Front-end developer',
    location: 'Pune, India',
    graduated: '2010',
    degree: 'M Tech',
    current_location: 'Bangalore',
    current_occupation: 'Entrepreneurship',
    current_company: 'Zoho',
    current_title: 'Project Lead',
    hobbies: 'Project Lead',
    personal_details: {
      about:
        'Lorem ipsum dolor sit amet consectetur. Pellentesque malesuada porta felis vestibulum volutpat volutpat imperdiet. Habitant ipsum hendrerit varius adipiscing augue sollicitudin sed. Pellentesque vel mauris quam neque urna. Amet scelerisque ut dolor duis dignissim in amet id proin.',
      Education: [
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2018',
          end_date: '2020',
          degree: 'Maters',
          field_of_study: 'Electronics and Media Technology',
          school: 'Presidency University',
        },
      ],
      work_experiance: [
        {
          start_date: '2021',
          end_date: '2022',
          designation: 'User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2022',
          end_date: '2023',
          designation: 'Senior User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2023',
          end_date: 'Present',
          designation: 'Project Lead',
          company_name: 'Lollipop Studio',
        },
      ],
      fun_fact: "The Ancient Romans used to drop a piece of toast into their wine for good health - hence why we 'raise a toast'.",
    },
  },
  {
    Id: '124krtj4432',
    image: 'https://cdn.pixabay.com/photo/2022/05/29/16/54/breakfast-7229532_640.jpg',
    name: 'Nikhil B',
    designation: 'Product Designer',
    location: 'Chennai, India',
    graduated: '2010',
    degree: 'M Tech',
    current_location: 'Bangalore',
    current_occupation: 'Entrepreneurship',
    current_company: 'Zoho',
    current_title: 'Project Lead',
    hobbies: 'Project Lead',
    personal_details: {
      about:
        'Lorem ipsum dolor sit amet consectetur. Pellentesque malesuada porta felis vestibulum volutpat volutpat imperdiet. Habitant ipsum hendrerit varius adipiscing augue sollicitudin sed. Pellentesque vel mauris quam neque urna. Amet scelerisque ut dolor duis dignissim in amet id proin.',
      Education: [
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2018',
          end_date: '2020',
          degree: 'Maters',
          field_of_study: 'Electronics and Media Technology',
          school: 'Presidency University',
        },
      ],
      work_experiance: [
        {
          start_date: '2021',
          end_date: '2022',
          designation: 'User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2022',
          end_date: '2023',
          designation: 'Senior User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2023',
          end_date: 'Present',
          designation: 'Project Lead',
          company_name: 'Lollipop Studio',
        },
      ],
      fun_fact: "The Ancient Romans used to drop a piece of toast into their wine for good health - hence why we 'raise a toast'.",
    },
  },
  {
    Id: '12444pkjdfb32',
    image: 'https://cdn.pixabay.com/photo/2018/06/27/07/45/college-student-3500990_640.jpg',
    name: 'Prateek K',
    designation: 'Executive',
    location: 'Mumbai, India',
    graduated: '2010',
    degree: 'M Tech',
    current_location: 'Bangalore',
    current_occupation: 'Entrepreneurship',
    current_company: 'Zoho',
    current_title: 'Project Lead',
    hobbies: 'Project Lead',
    personal_details: {
      about:
        'Lorem ipsum dolor sit amet consectetur. Pellentesque malesuada porta felis vestibulum volutpat volutpat imperdiet. Habitant ipsum hendrerit varius adipiscing augue sollicitudin sed. Pellentesque vel mauris quam neque urna. Amet scelerisque ut dolor duis dignissim in amet id proin.',
      Education: [
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2010',
          end_date: '2012',
          degree: 'Higher Sec',
          field_of_study: 'Computer Science',
          school: 'GRG Matric Hr Sec School',
        },
        {
          start_date: '2018',
          end_date: '2020',
          degree: 'Maters',
          field_of_study: 'Electronics and Media Technology',
          school: 'Presidency University',
        },
      ],
      work_experiance: [
        {
          start_date: '2021',
          end_date: '2022',
          designation: 'User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2022',
          end_date: '2023',
          designation: 'Senior User Experience Designer',
          company_name: 'Lollipop Studio',
        },
        {
          start_date: '2023',
          end_date: 'Present',
          designation: 'Project Lead',
          company_name: 'Lollipop Studio',
        },
      ],
      fun_fact: "The Ancient Romans used to drop a piece of toast into their wine for good health - hence why we 'raise a toast'.",
    },
  },
];

export { featuredCardData };
